(() => {
  'use strict';

  //if ('serviceWorker' in navigator) {
  //  window.addEventListener('load', function () {
  //    navigator.serviceWorker.register('/sw.js').then(function (registration) {
  //      // Registration was successful
  //      console.log('ServiceWorker registration successful with scope: ', registration.scope);
  //    }, function (err) {
  //      // registration failed :(
  //      console.log('ServiceWorker registration failed: ', err);
  //    });
  //  });
  //}

  document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.nav-link.dropdown-toggle').forEach(link => link.addEventListener('click', function (e) {
          e.preventDefault();
      }));

      document.querySelectorAll('.gallery-static').forEach(gallery => {
          let buttons = gallery.querySelectorAll('button');
          let images = gallery.querySelectorAll('.gallery-image');
          let activators = Array.from(buttons).concat(Array.from(images));
          for (let i = 0; i < activators.length; i++)
          {
              activators[i].addEventListener('click', function (e) {
                  e.preventDefault();
                  window.PhotoSwipeInterop.open(gallery, i);
              });
          }
      });

      new MutationObserver((mutations, observer) => {
          if (document.querySelector('#components-reconnect-modal h5 a')) {
          // Now every 10 seconds, see if the server appears to be back, and if so, reload
          async function attemptReload() {
              let response = await fetch(''); // Check the server really is back
              if (200 === response.status)
                  location.reload();
          }
          observer.disconnect();
          attemptReload();
          setInterval(attemptReload, 10000);
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

//window.LazyLoadInterop = (() => {
//    const observer = new IntersectionObserver(lazyLoad, {
//        threshold: 1.0
//    });

//    function isVisible(ref) {
//        const bounding = ref.getBoundingClientRect();
//        return (0 < bounding.top && bounding.top < (window.innerHeight || document.documentElement.clientHeight)) ||
//            (0 < bounding.bottom && bounding.bottom < (window.innerHeight || document.documentElement.clientHeight));
//    }

//    // Stop observing this image and load its source
//    function lazyLoad(elements) {
//        for (let i = 0; i < elements.length; i++) {
//            let item = elements[i];

//            if (item.intersectionRatio > 0) {
//                observer.unobserve(item.target);
//                loadImage(item.target);
//            };
//        }
//    };

//    // Update the image source on elements in the picture element
//    function loadImage(img) {
//        const picture = img.closest('picture');
//        const sources = picture ? picture.children : [img];
//        for (let i = 0; i < sources.length; i++) {
//            let source = sources[i];

//            // update the src or srcset urls
//            if (source.dataset.srcset)
//                source.srcset = source.dataset.srcset;

//            if (source.dataset.src)
//                source.src = source.dataset.src;

//            // remove the lazy-initial class when the full image is loaded to unblur
//            source.addEventListener('load', image => {
//                image.target.classList.remove('lazy');
//            }, false);
//        }
//    }

//    function startObserving(ref) {
//        // If the browser supports lazy loading, we can safely assign the src
//        // attributes without instantly triggering an eager image load.
//        //if ("loading" in HTMLImageElement.prototype || isVisible(ref)) {
//        if (isVisible(ref)) {
//            const picture = ref.closest('picture');
//            const sources = picture ? picture.children : [ref];
//            for (let i = 0; i < sources.length; i++) {
//                sources[i].style.transition = 'none';
//            }
//            ref.classList.remove('lazy');
//            loadImage(ref);
//        }
//        else {
//            observer.observe(ref);
//        }
//    }

//    document.addEventListener("DOMContentLoaded", () => {
//        const images = document.querySelectorAll('img.lazy');
//        for (let i = 0; i < images.length; i++) {
//            startObserving(images[i]);
//        }
//    });

//    return {
//        observe: startObserving
//    }
//})();

window.PhotoSwipeInterop = (() => {
    const galleries = {};

    function init(ref) {
      ref.classList.remove('gallery-static');
    }

    function open(ref, itemId) {
        let items = [];
        let figures = ref.querySelectorAll('figure');

        for (let i = 0; i < figures.length; i++) {
            let link = figures[i].querySelector('a');
            let item = {
                src: link.href,
                w: parseInt(link.dataset.width, 10),
                h: parseInt(link.dataset.height, 10),
                pid: link.dataset.uid
            };
            let caption = figures[i].querySelector('figcaption');
            if (caption) {
                item.title = caption.innerHTML;
            }

            items.push(item);
        }

        let pswpElement = document.querySelector('.pswp');
        let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            galleryUID: ref.id,
            galleryPIDs: true
        });
        gallery.init();
        for (let i = 0; i < gallery.items.length; i++) {
            if (gallery.items[i].pid == itemId) {
                gallery.goTo(i);
                break;
            }
        }
        galleries[ref.id] = gallery;
    }

    function destroy(ref) {
        if (galleries[ref.id])
            galleries[ref.id].destroy();
    }

    return {
        init: init,
        open: open,
        destroy: destroy
    }
})();

window.ZxcvbnInterop = (() => {
  'use strict';
  let _init = function (ref, dotNet) {
    ref.addEventListener("input", () => {
      let stats = zxcvbn(ref.value);
      dotNet.invokeMethodAsync("ScoreChanged", stats.score, stats.feedback ? stats.feedback.warning : null, stats.feedback ? stats.feedback.suggestions : []);
    });
  };

  return {
    init: _init
  };
})();